module.exports = __webpack_public_path__ + "static/z_tall_bjwright-1f8c2c5f7183ec49a7c6e00beadd409a.jpg";